// Actions
export var SET_SESSION_ID = "SET_SESSION_ID";
export var STAY_CONNECT = "STAY_CONNECT";
export var LAST_REQUEST = "LAST_REQUEST"; // Statut initial

export var INITIAL_STATE = {
  /**
   * Objet de session sauvegardé dans le store
   * @category Store
   * @typedef {object} SessionObject
   * @property {string} [id=null] Identifiant de session
   * @property {boolean} [stayConnect=false] true pour maintenir la connexion ouverte, false sinon
   * @property {date} [lastRequest=new Date(Date.now())] Date et heure de la dernière requête envoyée au serveur
   */
  session: {
    id: null,
    stayConnect: false,
    lastRequest: new Date(Date.now())
  }
};